import axiosInstance from '../../../api/axiosConfig';
import { Creative } from '../../../types/creative';

export const getCreatives = async () => {
    const response = await axiosInstance.get<Creative[]>('/creative');
    return response?.data;
};

export const createCreative = async (formData: any) => {
    const response = await axiosInstance.post<Creative>('/creative', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response?.data;
};

export const updateCreative = async (creative: Creative) => {
    const response = await axiosInstance.patch<Creative>(`/creative/${creative.id}`, creative);
    return response?.data;
};

export const deleteCreative = async (creative: Creative) => {
    const response = await axiosInstance.delete<Creative>(`/creative/${creative.id}`);
    return response?.data;
};
